import { TypedUseSelectorHook, useSelector } from "react-redux";
import { RootState } from "../interfaces/common";

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
